<div
  class="prominent-cell"
  [ngClass]="{ disabled: disabled, nested: nested, 'prominent-cell--bottom-border': showBottomBorder }"
  (click)="onCellClick()"
  (keyup.enter)="onCellClick()"
  tabindex="0"
  role="button"
  [attr.aria-disabled]="disabled"
>
  <div class="prominent-cell__label">{{ label }}</div>
  <div class="prominent-cell__value-wrapper">
    <span class="prominent-cell__value">{{ value }}</span>
    <bw-icon-legacy [iconName]="'chevron_right'" [color]="'var(--secondary-text)'" [size]="20"></bw-icon-legacy>
  </div>
</div>
